import { render, staticRenderFns } from "./questionInfoDialog.vue?vue&type=template&id=d2a925f4&scoped=true&"
import script from "./questionInfoDialog.vue?vue&type=script&lang=js&"
export * from "./questionInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./questionInfoDialog.vue?vue&type=style&index=0&id=d2a925f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a925f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VOverlay})
